import React, { useEffect, useRef } from 'react'
import { openAiSection } from '../../../utils/aiNavigation'
import { connect } from 'react-redux'
import {
    deviceDetails,
    deviceMismatch,
    graphPlotStorage,
    selecteInternalAcessories,
    showModal,
    webSerialConnect,
} from '../../../redux/actions'

import secondaryImg from '../../../Assets/Bisoft_UI/Buttons/Inactive with shadow/save - secondary@2x.png'
import style from '../DialogModal/DialogModal.module.css'
import strokeImg from '../../../Assets/Bisoft_UI/Buttons/Inactive with shadow/help@main.png'
import file from '../../../Assets/Bisoft_UI/Buttons/Inactive - without shadow/file.png'
import renderPrgImage from '../../../source/programImg'
import saveButton from '../../../Assets/Bisoft_UI/AppMode/save.png'
import renderImage from '../../../source/importImg'
import alignImage from '../../../Assets/flowchart/button 52x52 - stroke.png'
import { useHistory } from 'react-router'
import {
    connectSerialDevice,
    connectSerialDeviceInitial,
    connectSerialDeviceIntermediate,
    connectUSBDevice,
} from '../../WebSerialConnection/SerialUSBConnect'
import { portsData } from '../../Assembly/GraphPlotter/GraphPlotStorage'
import './ProgramHeader.css'
import { useState } from 'react'
import { saveAs } from 'file-saver'
import DialogModal from '../DialogModal/DialogModal'
import DeviceMissMatchPopupCom from './DeviceMissMatchPopupCom'
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import html2canvas from 'html2canvas'
import SaveGraph from '../../Assembly/GraphPlotter/newGraphUi/SaveGraph'
import { width } from '../../../helpers/Sizes'
import { clearFlowChartIfPannelData } from '../../../utils/removeSensorProgramData'
import { downloadAiProject } from '../../WebAi/aiProjectStore'
import { Download } from 'lucide-react'
import AiSaveDialog from '../../WebAi/AiSaveDialog'
import aiHeaderBtn from '../../../Assets/images/aiHeaderBtnFlat.svg'
import AiSelectModal from '../AiSelectModal/AiSelectModal'
import BatteryIndicator from '../ZingNotifications/BatteryIndicator'

function ProgramHeader({
    worker,
    webSerial,
    webSerialConnect,
    data,
    logic,
    showHelp,
    handleHelp,
    showSave,
    handleSave,
    showClear,
    handleClear,
    showFlowchartAlign,
    handleFlowchartAlign,
    showGraph,
    showModal,
    graph,
    viewActions,
    actionsList,
    device,
    deviceMismatch,
    deviceDetail,
    DeselectedComponent,
    concept,
    graphPlotStorage,
    graphPlotStorageReset,
    setSelectMultipleInternalAccessories,
    selecteComponent,
    logicComponent,
    showFirmwareUpdateDialog,
    stopPA = () => { },
    // musicDisable,
    // toggleSwipeBtnHandel = () => {},
    // isAudioEnable = true,
    isShowNewUI,
    socketData,
    fileSaveClick = () => { },
    isShowProjectName = false,
    projectName = 'Name',
    setCreateActionState = () => { },
    isSaveToBoard = false,
    chartRef,
    styles = {},
    isShowBack = false,
    isShowTitle = false,
    goBack = () => { },
    singleTitle = '',
    showAiBtn = false,
}) {
    // const [fileName, setFileName] = useState('')
    // const [filePopup, setFilePopUp] = useState(false)
    // const [isDeviceMismatch, setIsDeviceMismatch] = useState(false)
    // const [showErrorMsg, setShowErrorMsg] = useState(false)
    const [valueName, setValueName] = useState(projectName)
    const [showInputName, setShowInputName] = useState(false)
    // AI Studio save-to-library dialog (name/description/images -> IndexedDB).
    const [showAiSaveDialog, setShowAiSaveDialog] = useState(false)
    const [showAiSelectModal, setShowAiSelectModal] = useState(false)
    const isWebAiMode = sessionStorage.getItem('webAiMode') === 'true'
    const [selectedRunGraph, setSelectedRunGraph] = useState('select')
    const [plotData1, setPlotData1] = useState([])
    const [showErrorMessage, setShowErrorMessage] = useState({
        show: false,
        message: '',
    })
    const [showDialogBoxes, setShowDialogBoxes] = useState({
        showErrorMsg: false,
        isDeviceMismatch: false,
        filePopup: false,
    })
    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const deviceVersion = sessionStorage.getItem('deviceVersion')
    const inputNameRef = useRef(null)
    let history = useHistory()
    var newFileName = ''

    let deviceName = ''
    switch (connectedDevice) {
        case 'Hexapod':
            deviceName = 'Crawl-e'
            break
        default:
            deviceName = 'Zing'
    }

    useEffect(() => {
        setValueName(projectName)
    }, [projectName])

    const handleUSB = async () => {
        if (!webSerial.isConnected) {
            let res = await connectSerialDeviceIntermediate(
                { isAutomatic: false },
                worker,
                socketData
            )

            if (res !== undefined) {
                if (res.matchedObj_with_Version?.firmwareUnsupported) {
                    // Unsupported firmware must never be accepted as the
                    // connected device — show the firmware update dialog
                    // directly instead of the generic device-mismatch popup.
                    const mismatchedDevice = res.matchedObj_with_Version
                    showFirmwareUpdateDialog({
                        currentVersion: mismatchedDevice.currentVersion,
                        latestVersion: mismatchedDevice.minFirmware,
                        deviceName: mismatchedDevice.id,
                        firmwareCheck: { mandatory: true },
                    })
                } else if (!res.isPortOpen) {
                    deviceMismatch({
                        deviceMismatched: res.matchedObj_with_Version,
                        isMemoryPresent: res.isMemoryPresent,
                        isArmError: res.isArmError,
                        is2In1Sensor: res.is2In1Sensor,
                        plodeNativeData: {
                            ...device.plodeNativeData,
                            mountPoint: res.mountPoint,
                        },
                    })
                    setShowDialogBoxes({
                        ...showDialogBoxes,
                        isDeviceMismatch: true,
                    })
                } else {
                    setShowDialogBoxes({
                        ...showDialogBoxes,
                        isDeviceMismatch: false,
                    })
                    deviceMismatch({
                        deviceMismatched: {},
                        isMemoryPresent: res.isMemoryPresent,
                        isArmError: res.isArmError,
                        is2In1Sensor: res.is2In1Sensor,
                        plodeNativeData: {
                            ...device.plodeNativeData,
                            mountPoint: res.mountPoint,
                        },
                    })
                }

                if (res.is2In1Sensor) {
                    graphPlotStorageReset({
                        isColorSensor: false,
                        isRedLight: false,
                        isGreenLight: false,
                        isBlueLight: false,
                        isGestureSensor: false,
                    })
                    setSelectMultipleInternalAccessories({
                        isRedLight: false,
                        isBlueLight: false,
                        isGreenLight: false,
                        isGestureSensor: false,
                    })
                    DeselectedComponent({
                        isColorSensor: false,
                        isGestureSensor: false,
                    })

                    const removeReduxLogicState = (program) => {
                        program.map((data) => {
                            if (data.type === 'sensor') {
                                let dataSorce = data?.state?.source?.replace(
                                    /\s+/g,
                                    '_'
                                )
                                if (
                                    [
                                        '4-IN-1_SENSOR_→_RED',
                                        '4-IN-1_SENSOR_→_BLUE',
                                        '4-IN-1_SENSOR_→_GREEN',
                                        '4-IN-1_SENSOR_→_GESTURE',
                                    ].includes(dataSorce)
                                ) {
                                    data.state.source = ''
                                    data.state.value = 0
                                    data.state.value2 = 0
                                    data.state.condition = ''
                                }

                                data.subprogram = removeReduxLogicState(
                                    data.subprogram
                                )
                            }
                        })

                        return program
                    }

                    if (logic?.program) {
                        let newLogic = { ...logic }
                        newLogic.program = removeReduxLogicState(
                            newLogic.program
                        )

                        logicComponent(newLogic)
                    }

                    if (
                        sessionStorage.getItem('programMode') ===
                        'flowchartBased'
                    ) {
                        clearFlowChartIfPannelData(
                            sessionStorage.getItem('flowchart-elements'),
                            [
                                'colorSensorRed',
                                'colorSensorGreen',
                                'colorSensorBlue',
                                'gestureSensor',
                            ]
                        )

                        sessionStorage.setItem('isColorSensor', false)
                        sessionStorage.setItem('isGestureSensor', false)
                    }
                }
            }

            if (res) {
                webSerialConnect({ port: res.port })
            } else {
                setShowDialogBoxes({ ...showDialogBoxes, showErrorMsg: true })
            }
        }
    }

    //for mismatch of device while connecting
    const handleDevice = async (option) => {
        if (option === 'no') {
            let port = webSerial.port
            //is this needed??
            // await openSerialReadComPort(port,worker)
        } else if (device.deviceMismatched?.firmwareUnsupported) {
            // Unsupported firmware must never be accepted as the connected
            // device — show the firmware update dialog after the mismatch is
            // acknowledged, instead of accepting the connection.
            const mismatchedDevice = device.deviceMismatched
            showFirmwareUpdateDialog({
                currentVersion: mismatchedDevice.currentVersion,
                latestVersion: mismatchedDevice.minFirmware,
                deviceName: mismatchedDevice.id,
                firmwareCheck: { mandatory: true },
            })
        } else {
            shouldErase()
            history.push('/Selection')
            let mismatchedDevice = device.deviceMismatched
            sessionStorage.setItem('connectedDevice', mismatchedDevice.id)
            // if (['Ace','Hexapod'].includes(mismatchedDevice.id)) {
            sessionStorage.setItem('deviceVersion', mismatchedDevice.version)
            if (webSerial.isConnected)
                sessionStorage.setItem('isDeviceConnected', true)
            deviceDetail({
                connectedDevice: mismatchedDevice.id,
                deviceVersion: mismatchedDevice.version,
            })
            // } else {
            //     sessionStorage.setItem('zingVersion', mismatchedDevice.version)
            //     deviceDetail({
            //         connectedDevice: mismatchedDevice.id,
            //         zingVersion: mismatchedDevice.version,
            //         deviceVersion: '0.0.0',
            //     })
            // }
        }
        setShowDialogBoxes({ ...showDialogBoxes, isDeviceMismatch: false })
        deviceMismatch({ deviceMismatched: {} })
    }

    const shouldErase = () => {
        let programMode = sessionStorage.programMode
        let connectedDevice = sessionStorage.connectedDevice
        let version = sessionStorage.deviceVersion
        let recoveryData = JSON.parse(localStorage.getItem('recoveryData'))
        if (
            localStorage.getItem('recoveryData') !== null &&
            programMode in recoveryData &&
            connectedDevice in recoveryData[programMode] &&
            version in recoveryData[programMode][connectedDevice]
        ) {
            if (Object.keys(recoveryData).length === 1) {
                if (Object.keys(recoveryData[programMode]).length === 1) {
                    if (
                        Object.keys(recoveryData[programMode][connectedDevice])
                            .length === 1
                    ) {
                        localStorage.removeItem('recoveryData')
                    } else {
                        delete recoveryData[programMode][connectedDevice][
                            version
                        ]
                        localStorage.setItem(
                            'recoveryData',
                            JSON.stringify(recoveryData)
                        )
                    }
                } else {
                    if (
                        Object.keys(recoveryData[programMode][connectedDevice])
                            .length === 1
                    ) {
                        delete recoveryData[programMode][connectedDevice]
                    } else {
                        delete recoveryData[programMode][connectedDevice][
                            version
                        ]
                    }
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(recoveryData)
                    )
                }
            } else {
                if (Object.keys(recoveryData[programMode]).length === 1) {
                    if (
                        Object.keys(recoveryData[programMode][connectedDevice])
                            .length === 1
                    ) {
                        delete recoveryData[programMode]
                    } else {
                        delete recoveryData[programMode][connectedDevice][
                            version
                        ]
                    }
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(recoveryData)
                    )
                } else {
                    if (
                        Object.keys(recoveryData[programMode][connectedDevice])
                            .length === 1
                    ) {
                        delete recoveryData[programMode][connectedDevice]
                    } else {
                        delete recoveryData[programMode][connectedDevice][
                            version
                        ]
                    }
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(recoveryData)
                    )
                }
            }
        }
        var arr = Object.keys(sessionStorage)
        for (const i of arr) {
            if (
                i != 'connectedDevice' &&
                i != 'Hardware' &&
                i != 'userData' &&
                i != 'concept' &&
                i != 'webSerialPortList' &&
                i != 'user' &&
                i != 'deviceVersion' &&
                i != 'programMode' &&
                i != 'isWindowOnFocus' &&
                i != 'slideDirection' &&
                i != 'versionData' &&
                i != 'coverflowActive'
            ) {
                //arr.push(i);
                sessionStorage.removeItem(i)
                // console.log(i, "sess");
            }
        }
        sessionStorage.setItem('pip', false)
        sessionStorage.setItem('name', 'null')
        sessionStorage.setItem('GraphData', false)
        sessionStorage.setItem('shield', 'false')
        sessionStorage.setItem('peeCeeATR', 'false')
        sessionStorage.setItem('arm_shield', 'false')
        sessionStorage.setItem('slideDirection', true)
        concept.Index = []
        concept.counter = []
        DeselectedComponent({
            Four_in_one_sensor: {
                isDistanceSensors: false,
                isGestureSensor: false,
                isLightSensor: false,
                isColorSensor: false,
            },
            isFour_in_one_sensor: false,

            // input
            isTouchZero: false,
            isTouchOne: false,
            isTouchTwo: false,
            isTouchThree: false,
            // output
            isTouchZeroOutput: false,
            isTouchOneOutput: false,
            isTouchTwoOutput: false,
            isTouchThreeOutput: false,

            isMic: false,
            isTemperature: false,
            isBattery: false,
            isAccelerometer: false,

            isLeftEye: false,
            isRightEye: false,
            isEYES: false,
            isbuzzer: false,

            isSmileOne: false,
            isSmileTwo: false,
            isSmileThree: false,
            isSmileFour: false,
            //humanoid
            isBattery: false,
            isUltrasonic: false,
            isAccelerometer: false,
            isGyroX: false,
            isGyroY: false,
            isGyroZ: false,
            isAccelerometerX: false,
            isUltrasonic: false,
            isAccelerometerY: false,
            isAccelerometerZ: false,
            // output
            isLeftRGB: false,
            isRightRGB: false,
            isMp3: false,
            isHeadServo: false,
            isIndivdualServo: false,
            isActionGroup: false,
            isM1: false,
            isM2: false,
            isSimpleServo: false,
        })
        DeselectedComponent({
            portsData: [
                {
                    key: 'A',
                    ports: [
                        {
                            portName: 'A1',
                            isActive: false,
                            isDigital: false,
                            isColor: '#E25432',
                        },
                        {
                            portName: 'A2',
                            isActive: false,
                            isDigital: false,
                            isColor: '#B0D745',
                        },
                    ],
                },

                {
                    key: 'B',
                    ports: [
                        {
                            portName: 'B1',
                            isActive: false,
                            isDigital: false,
                            isColor: '#23DE93',
                        },
                        {
                            portName: 'B2',
                            isActive: false,
                            isDigital: false,
                            isColor: '#3A3A3A',
                        },
                    ],
                },

                {
                    key: 'C',
                    ports: [
                        {
                            portName: 'C1',
                            isActive: false,
                            isDigital: false,
                            isColor: '#0ACEF7',
                        },
                        {
                            portName: 'C2',
                            isActive: false,
                            isDigital: false,
                            isColor: '#5061A8',
                        },
                    ],
                },

                {
                    key: 'D',
                    ports: [
                        {
                            portName: 'D1',
                            isActive: false,
                            isDigital: false,
                            isColor: '#0E3C11',
                        },
                        {
                            portName: 'D2',
                            isActive: false,
                            isDigital: false,
                            isColor: '#DD1624',
                        },
                    ],
                },

                {
                    key: 'E',
                    ports: [
                        {
                            portName: 'E1',
                            isActive: false,
                            isDigital: false,
                            isColor: '#F79B47',
                        },
                        {
                            portName: 'E2',
                            isActive: false,
                            isDigital: false,
                            isColor: '#F666D0',
                        },
                    ],
                },

                {
                    key: 'F',
                    ports: [
                        {
                            portName: 'F1',
                            isActive: false,
                            isDigital: false,
                            isColor: '#3D5B53',
                        },
                        {
                            portName: 'F2',
                            isActive: false,
                            isDigital: false,
                            isColor: 'black',
                        },
                    ],
                },
            ],
        })
        graphPlotStorageReset({
            time: { h: 0, m: 0, s: 0, ms: 0 },
            Four_in_one_sensor: {
                isDistanceSensors: false,
                isGestureSensor: false,
                isLightSensor: false,
                isColorSensor: false,
            },

            // input
            isTouchZero: false,
            isTouchOne: false,
            isTouchTwo: false,
            isTouchThree: false,
            isMic: false,
            isTemperature: false,
            isBattery: false,
            isAccelerometer: false,
            isAccelerometerX: false,
            isAccelerometerY: false,
            isAccelerometerZ: false,
            isGyroX: false,
            isGyroY: false,
            isGyroZ: false,
            isUltrasonic: false,
            portsData,
        })
        portsData[0] = {
            key: 'A',
            ports: [
                {
                    portName: 'A1',
                    isActive: false,
                    isDigital: false,
                    isColor: '#E25432',
                },
                {
                    portName: 'A2',
                    isActive: false,
                    isDigital: false,
                    isColor: '#B0D745',
                },
            ],
        }

        portsData[1] = {
            key: 'B',
            ports: [
                {
                    portName: 'B1',
                    isActive: false,
                    isDigital: false,
                    isColor: '#23DE93',
                },
                {
                    portName: 'B2',
                    isActive: false,
                    isDigital: false,
                    isColor: '#3A3A3A',
                },
            ],
        }

        portsData[2] = {
            key: 'C',
            ports: [
                {
                    portName: 'C1',
                    isActive: false,
                    isDigital: false,
                    isColor: '#0ACEF7',
                },
                {
                    portName: 'C2',
                    isActive: false,
                    isDigital: false,
                    isColor: '#5061A8',
                },
            ],
        }

        portsData[3] = {
            key: 'D',
            ports: [
                {
                    portName: 'D1',
                    isActive: false,
                    isDigital: false,
                    isColor: '#0E3C11',
                },
                {
                    portName: 'D2',
                    isActive: false,
                    isDigital: false,
                    isColor: '#DD1624',
                },
            ],
        }

        portsData[4] = {
            key: 'E',
            ports: [
                {
                    portName: 'E1',
                    isActive: false,
                    isDigital: false,
                    isColor: '#F79B47',
                },
                {
                    portName: 'E2',
                    isActive: false,
                    isDigital: false,
                    isColor: '#F666D0',
                },
            ],
        }

        portsData[5] = {
            key: 'F',
            ports: [
                {
                    portName: 'F1',
                    isActive: false,
                    isDigital: false,
                    isColor: '#3D5B53',
                },
                {
                    portName: 'F2',
                    isActive: false,
                    isDigital: false,
                    isColor: 'black',
                },
            ],
        }
    }
    const handleError = async () => {
        setShowDialogBoxes({ ...showDialogBoxes, showErrorMsg: false })
        window.location.reload()
    }

    //when device is disconnect set the mismatch empty
    useEffect(() => {
        if (sessionStorage.getItem('isDeviceConnected') == 'false') {
            setShowDialogBoxes({
                ...showDialogBoxes,
                isDeviceMismatch: false,
            })
            deviceMismatch({ deviceMismatched: {} })
        }
    }, [webSerial.isConnected])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                inputNameRef.current &&
                !inputNameRef.current.contains(event.target)
            )
                setName()
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [valueName])
    const deviceMismatched = device && device.deviceMismatched
    useEffect(() => {
        if (deviceMismatched) {
            let deviceD = Object.keys(deviceMismatched)
            if (deviceD.length > 1) {
                if (showDialogBoxes.isDeviceMismatch == false) {
                    setShowDialogBoxes({
                        ...showDialogBoxes,
                        isDeviceMismatch: true,
                    })
                }
            }
        }
    }, [deviceMismatched])

    const saveFile = () => {
        sessionStorage.setItem('isSave', JSON.stringify(true))
        if (graph) {
            const csvHeader = Object.keys(graph[0]).join(',')
            const csvRows = graph
                .map((obj) => Object.values(obj).join(','))
                .join('\n')
            const csvString = `${csvHeader}\n${csvRows}`
            const blob = new Blob([csvString], { type: 'text/csv' })
            if (newFileName.length !== 0) saveAs(blob, `${newFileName}.csv`)
            return
        }

        // Inside the A.I. Studio, a "project" is more than sessionStorage: it
        // also carries the trained models (TF.js + ProgrammingPage IndexedDB)
        // and the appModeStorage slice. Download that full bundle instead of the
        // plain sessionStorage dump. Scope is AI-only, so normal projects are
        // unaffected.
        if (sessionStorage.getItem('webAiMode') === 'true') {
            if (newFileName.length !== 0) downloadAiProject(newFileName)
            return
        }

        const fileData = JSON.stringify(sessionStorage)
        const blob = new Blob([fileData], { type: 'text/plain' })
        if (newFileName.length !== 0) saveAs(blob, `${newFileName}.pld`)
    }

    //condition to show the dilogModel for zing v2 and cralwe v2 memory card present or not
    // or show the arm for zing has wrong position dilogModel condition.
    const isShowMemoryCardModel = () => {
        const path = window.location.pathname
        const isDeviceVersion2 = ['2', '3'].includes(deviceVersion?.[0])
        const isWebSerialConnected = webSerial.isConnected
        const isDeviceMismatch = showDialogBoxes.isDeviceMismatch
        const isMemoryError = !device.isMemoryPresent

        const validConditions =
            isDeviceVersion2 &&
            isWebSerialConnected &&
            !isDeviceMismatch &&
            isMemoryError

        const deviceConditions = {
            // Humanoid: validConditions, // replaced by the firmware SD-card notification
            Humanoid: false,
            Hexapod:
                validConditions &&
                [
                    '/code/project/action/select',
                    '/code/project/action/create',
                ].includes(path),
        }

        return deviceConditions?.[connectedDevice] || false
    }

    const setName = () => {
        if (valueName.trim().length === 0 || valueName.trim().length > 10) {
            setShowErrorMessage({
                message: 'File name content minimum 1 to maximum 10 character.',
                show: true,
            })
            setTimeout(() => {
                setShowErrorMessage({
                    message: '',
                    show: false,
                })
            }, 2000)
            return
        }
        const validNamePattern = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/
        if (!validNamePattern.test(valueName.trim())) {
            setShowErrorMessage({
                message: 'This is not a valid file name.',
                show: true,
            })
            setTimeout(() => {
                setShowErrorMessage({
                    message: '',
                    show: false,
                })
            }, 2000)
            return
        }
        setCreateActionState((prev) => {
            return { ...prev, projectName: valueName.trim() }
        })
        setShowInputName(false)
    }

    const handelSubmitName = (e) => {
        e.preventDefault()
        setName()
    }

    const RenderFileName = () => {
        const [fileName, setFileName] = useState('')

        let inputHandler = (event) => {
            setFileName(event.target.value)
            newFileName = event.target.value
        }

        const handelGraphRunChange = (e) => {
            setSelectedRunGraph(e.target.value)

            const newSelectedRunGraph = e.target.value
            let newPlotData = []
            if (newSelectedRunGraph === 'selectAll') {
                Object.keys(graphPlotStorage?.graphRunInfo).map((objKey) => {
                    newPlotData = [
                        ...newPlotData,
                        ...graphPlotStorage?.graphRunInfo?.[objKey].plotData,
                    ]
                })
            } else {
                newPlotData =
                    graphPlotStorage?.graphRunInfo?.[newSelectedRunGraph]
                        ?.plotData || []
            }
            setPlotData1(newPlotData)
        }

        //handel graph data save as Excel
        const saveAsExcel = () => {
            if (selectedRunGraph === 'select' && !fileName) {
                return
            }

            const worksheet = XLSX.utils.json_to_sheet(plotData1)
            const workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook, worksheet, 'GraphData')
            XLSX.writeFile(workbook, `${fileName}.xlsx`)
            setShowDialogBoxes({
                showErrorMsg: false,
                isDeviceMismatch: false,
                filePopup: false,
            })
        }

        //handel graph data save as pdf
        const saveAsPdf = () => {
            if (selectedRunGraph === 'select' && !fileName) {
                return
            }
            let plotData = []
            if (selectedRunGraph === 'selectAll') {
                Object.keys(graphPlotStorage?.graphRunInfo).map((objKey) => {
                    plotData = [
                        ...plotData,
                        ...graphPlotStorage?.graphRunInfo?.[objKey].plotData,
                    ]
                })
            } else {
                plotData =
                    graphPlotStorage?.graphRunInfo?.[selectedRunGraph]
                        ?.plotData || []
            }
            const doc = new jsPDF()
            const headers = [Object.keys(plotData[0])]
            const rows = plotData.map((row) => Object.values(row))
            doc.text('Graph Data Report', 14, 15)
            autoTable(doc, {
                startY: 20,
                head: headers,
                body: rows,
            })
            doc.save(`${fileName}.pdf`)
            setShowDialogBoxes({
                showErrorMsg: false,
                isDeviceMismatch: false,
                filePopup: false,
            })
        }

        return (
            <>
                {showDialogBoxes.filePopup && (
                    <div className={style.container} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div
                            className={style.box}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                position: 'relative',
                                gap: '15px',
                                padding: '30px'
                            }}
                        >
                            <img
                                className={style.closeBtn}
                                style={{ width: '2.5rem', cursor: 'pointer', position: 'absolute', right: '15px', top: '15px' }}
                                src={renderImage('clos')}
                                onClick={() => {
                                    setShowDialogBoxes({
                                        ...showDialogBoxes,
                                        filePopup: false,
                                    })
                                }}
                            />
                            {graph && (
                                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <p style={{ margin: '10px 0' }}>Select Run Export</p>
                                    {graphPlotStorage?.graphRunInfo &&
                                        Object.keys(graphPlotStorage?.graphRunInfo)
                                            ?.length > 0 ? (
                                        <select
                                            value={selectedRunGraph}
                                            className="headerRunDropDown"
                                            onChange={handelGraphRunChange}
                                        >
                                            <option value="select">
                                                Select
                                            </option>
                                            {Object.keys(
                                                graphPlotStorage?.graphRunInfo
                                            )?.map((objKey) => (
                                                <option
                                                    key={objKey}
                                                    value={objKey}
                                                >
                                                    {
                                                        graphPlotStorage
                                                            ?.graphRunInfo?.[
                                                            objKey
                                                        ]?.label
                                                    }
                                                </option>
                                            ))}
                                            <option value="selectAll">
                                                All Data
                                            </option>
                                        </select>
                                    ) : (
                                        <div className="headerRunDropDown">
                                            No Data
                                        </div>
                                    )}
                                </div>
                            )}
                            <input
                                placeholder="Enter the file name"
                                style={{
                                    width: '15vw',
                                    height: '4.5vh',
                                    backgroundColor: 'lightgrey',
                                    textAlign: 'center',
                                    borderRadius: '5px',
                                    border: 'none',
                                    padding: '5px'
                                }}
                                type="text"
                                value={fileName}
                                autoFocus={true}
                                onChange={inputHandler}
                            />
                            {!graph && (
                                <img
                                    src={saveButton}
                                    draggable="false"
                                    style={{
                                        cursor: 'pointer',
                                        width: '8vw',
                                        marginTop: '10px'
                                    }}
                                    onClick={() => {
                                        setShowDialogBoxes({
                                            ...showDialogBoxes,
                                            filePopup: false,
                                        })
                                        saveFile()
                                    }}
                                />
                            )}
                            {graph && (
                                <div className="headerPdfSaveBtnDiv">
                                    <button
                                        onClick={saveAsPdf}
                                        className="headerPdfSaveBtn"
                                    >
                                        Save as PDF
                                    </button>
                                    <button
                                        onClick={saveAsExcel}
                                        className="headerPdfSaveBtn"
                                    >
                                        Save as Excel
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </>
        )
    }
    const handleGraph = () => {
        history.push('/graphPlotter')
    }

    return (
        <>
            <AiSelectModal
                show={showAiSelectModal}
                onClose={() => setShowAiSelectModal(false)}
                onSelect={() => {
                    setShowAiSelectModal(false)
                    openAiSection(history)
                }}
            />
            {showAiSaveDialog && (
                <AiSaveDialog onClose={() => setShowAiSaveDialog(false)} />
            )}
            <DialogModal
                mismatchShow={showDialogBoxes.isDeviceMismatch}
                text={<DeviceMissMatchPopupCom />}
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setShowDialogBoxes({
                        ...showDialogBoxes,
                        isDeviceMismatch: false,
                    })
                }
                optionsToSelect={[
                    {
                        text: 'YES',
                        do: () => handleDevice('yes'),
                    },
                ]}
            />
            <DialogModal
                mismatchShow={isShowMemoryCardModel()}
                text={
                    !device.isMemoryPresent
                        ? `There is no memory card inserted in ${deviceName}. \nkindly insert one to use the application further.`
                        : ''
                }
                showCloseBtn={false}
                optionsToSelect={[
                    {
                        text: 'YES',
                        do: () =>
                            history.push(
                                connectedDevice === 'Hexapod'
                                    ? '/code/project/'
                                    : '/kitSelection'
                            ),
                    },
                ]}
            />
            <DialogModal
                showError={showDialogBoxes.showErrorMsg}
                text={
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <p
                            style={{
                                transform: 'translateY(20%)',
                                fontSize: '2.5vh',
                            }}
                        >
                            Error in connecting the device!
                        </p>
                        <p
                            style={{
                                transform: 'translateY(20%)',
                                fontSize: '2vh',
                            }}
                        >
                            Please disconnect the device and try connecting
                            again.
                        </p>
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setShowDialogBoxes({
                        ...showDialogBoxes,
                        showErrorMsg: false,
                    })
                }
                optionsToSelect={[
                    {
                        text: 'OK',
                        do: handleError,
                    },
                ]}
            />

            <div id="HeaderContainer">
                <RenderFileName />
                <div
                    id='navbarContainer'
                    className="flowchart-navbarContainer"
                    style={{ zIndex: '1000', ...styles?.headerBar }}
                >
                    {/* Left Section (CSS Stepper + Title) */}
                    <div className="navbar-left-section">
                        {data.options && data.options.length > 0 && (
                            <div className="css-stepper-container">
                                {/* The active purple chevron background */}
                                <div
                                    className="css-stepper-active-bg"
                                    style={{
                                        width: `${((data.selected + 1) / data.options.length) * 100}%`
                                    }}
                                />

                                {/* The Text Items */}
                                {data.options.map((option, index) => {
                                    const isActive = index <= data.selected;
                                    return (
                                        <div
                                            key={index}
                                            className={`css-stepper-step ${isActive ? 'isActive' : 'notActive'}`}
                                            style={{ width: `${100 / data.options.length}%` }}
                                        >
                                            {isShowProjectName &&
                                                isShowNewUI &&
                                                index === 0 ? (
                                                <div className="programHeaderNameDiv">
                                                    {!showInputName ? (
                                                        <div className="programHeaderNameInnerDiv">
                                                            <p style={{ marginBottom: '0' }}>
                                                                {valueName}
                                                            </p>
                                                            <img
                                                                src={renderImage('edit')}
                                                                alt="editBtn"
                                                                onClick={() => setShowInputName(true)}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <form onSubmit={handelSubmitName}>
                                                            <input
                                                                ref={inputNameRef}
                                                                type="text"
                                                                value={valueName}
                                                                onChange={(e) => setValueName(e.target.value)}
                                                            />

                                                            {showErrorMessage.show && (
                                                                <p className="actionProjectNameError">
                                                                    {showErrorMessage.message}
                                                                </p>
                                                            )}
                                                        </form>
                                                    )}
                                                </div>
                                            ) : (
                                                <p>{option}</p>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {isShowTitle && (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    marginLeft: '15px'
                                }}
                            >
                                <p style={{ marginBottom: '0' }}>{singleTitle}</p>
                            </div>
                        )}
                    </div>

                    {/* Right Section (Action Buttons) */}
                    <div className="flowchart-navbar-Action navbar-Action">
                        {showAiBtn && (
                            <div className="help_button">
                                <img
                                    id="iconBtnSize"
                                    src={aiHeaderBtn}
                                    onClick={() => setShowAiSelectModal(true)}
                                    alt="AI"
                                />
                                <span
                                    className="tooltiptext saveTooltiptext"
                                    style={{ alignItems: 'center' }}
                                >
                                    <p>AI</p>
                                </span>
                            </div>
                        )}

                        {showGraph && (
                            <img
                                id="iconBtnSize"
                                src={renderPrgImage('graphbtn')}
                                onClick={handleGraph}
                                alt="Graph"
                            />
                        )}

                        {showSave && (
                            <div className="help_button">
                                <img
                                    id="iconBtnSize"
                                    src={secondaryImg}
                                    onClick={() => {
                                        // A.I. Studio: Save stores the project in
                                        // the on-device library (IndexedDB) via a
                                        // name/description/images dialog. Download
                                        // (the button beside it) still makes a file.
                                        if (isWebAiMode) {
                                            stopPA()
                                            setShowAiSaveDialog(true)
                                            return
                                        }
                                        if (isShowNewUI || isSaveToBoard) {
                                            fileSaveClick()
                                            return
                                        }
                                        stopPA()
                                        setShowDialogBoxes({
                                            ...showDialogBoxes,
                                            filePopup: true,
                                        })
                                    }}
                                    alt="Save"
                                />
                                <span className="tooltiptext saveTooltiptext">
                                    <p>Save</p>
                                </span>
                            </div>
                        )}

                        {showSave && isWebAiMode && (
                            <div className="help_button">
                                <span
                                    id="iconBtnSize"
                                    className="programheader_aiDownload"
                                    onClick={() => {
                                        stopPA()
                                        setShowDialogBoxes({
                                            ...showDialogBoxes,
                                            filePopup: true,
                                        })
                                    }}
                                    role="button"
                                    aria-label="Download"
                                >
                                    <Download size={26} strokeWidth={1.5} color="#25245e" />
                                </span>
                                <span className="tooltiptext saveTooltiptext">
                                    <p>Download</p>
                                </span>
                            </div>
                        )}

                        {showFlowchartAlign && (
                            <div className="help_button">
                                <img
                                    id="iconBtnSize"
                                    src={alignImage}
                                    onClick={handleFlowchartAlign}
                                    alt="Align"
                                />
                                <span className="tooltiptext">
                                    <p>Align</p>
                                </span>
                            </div>
                        )}

                        {showClear && (
                            <div className="help_button">
                                <img
                                    id="iconBtnSize"
                                    src={renderPrgImage('clearProgram')}
                                    onClick={handleClear}
                                    // style={{ transform: 'scale(0.8)' }}
                                    alt="Clear"
                                />
                                <span className="tooltiptext clearTooltiptext">
                                    <p>Clear</p>
                                </span>
                            </div>
                        )}

                        {showHelp && (
                            <div className="help_button">
                                <img
                                    id="iconBtnSize"
                                    src={strokeImg}
                                    onClick={handleHelp}
                                    alt="Help"
                                />
                                <span className="tooltiptext saveTooltiptext">
                                    <p>Help</p>
                                </span>
                            </div>
                        )}

                        {viewActions && (
                            <div className="file_open">
                                <img
                                    id="iconBtnSize"
                                    src={file}
                                    onClick={() => {
                                        actionsList(true)
                                    }}
                                    alt="View Actions"
                                />
                                <span className="tooltiptext saveTooltiptext">
                                    <p>Open Save Actions</p>
                                </span>
                            </div>
                        )}

                        <div className="web_button usb_button">
                            <img
                                className={`usb_icon ${
                                    webSerial.isConnected
                                        ? 'usb_icon_on'
                                        : 'usb_icon_off'
                                }`}
                                src={renderPrgImage(
                                    webSerial.isConnected ? 'usbON' : 'usbOFF'
                                )}
                                onClick={handleUSB}
                                alt={
                                    webSerial.isConnected
                                        ? 'Connected'
                                        : 'Disconnected'
                                }
                            />
                            <span className="tooltiptext saveTooltiptext">
                                <p>
                                    Device <br /> connectivity
                                </p>
                            </span>
                            <BatteryIndicator />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        webSerialConnect: (data) => {
            dispatch(webSerialConnect(data))
        },

        showModal: (data) => {
            dispatch(showModal(data))
        },
        deviceMismatch: (data) => {
            dispatch(deviceMismatch(data))
        },
        deviceDetail: (data) => {
            dispatch(deviceDetails(data))
        },
        //this is for hex programming
        DeselectedComponent: (data) => {
            dispatch(selecteInternalAcessories(data))
        },
        graphPlotStorageReset: (data) => {
            dispatch(graphPlotStorage(data))
        },
        //this is for graph plot storage
        setSelectMultipleInternalAccessories: (data) => {
            dispatch({
                type: 'SET_SELECT_INTERNAL_ACCESSORIES_MULTI',
                payload: data,
            })
        },
        logicComponent: (data) => {
            dispatch({ type: 'LOGIC_SELECTION', payload: data })
        },
        showFirmwareUpdateDialog: (payload) => {
            dispatch({ type: 'SHOW_FIRMWARE_UPDATE_DIALOG', payload })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProgramHeader)